<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <div class="item">预约状态：{{form.beforeStr.orderMap.status | setState}}</div>
          <div class="title-box"><span class="txt1">预约用户信息</span></div>
          <div class="item">姓名：{{form.beforeStr.customerMap.name}}</div>
           <div class="item">电话：{{form.beforeStr.customerMap.pho}}</div>
           <div class="item">身份：{{form.beforeStr.customerMap.level_name}}</div>
           <div class="title-box" v-if="form.beforeStr.techInfoMap"><span class="txt1">技术老师信息</span></div>
           <div class="item" v-if="form.beforeStr.techInfoMap">姓名：{{form.beforeStr.techInfoMap.real_name}}</div>
            <div class="item" v-if="form.beforeStr.techInfoMap">电话：{{form.beforeStr.techInfoMap.mobile}}</div>
            <div class="item" v-if="form.beforeStr.techInfoMap">身份：{{form.beforeStr.techInfoMap.level_name}}</div>
           <div class="title-box"><span class="txt1">预约信息</span></div>

           <div class="item">预约类型：{{form.beforeStr.orderMap.type==10?'线下服务':'线上服务'}}</div>
           <div class="item">服务类型：{{form.beforeStr.orderMap.service_items}}</div>
           <div class="item">地址：{{form.beforeStr.orderMap.address}}</div>
           <div class="item">排期时间：{{form.beforeStr.orderMap.start_time}}-{{form.beforeStr.orderMap.end_time}}</div>
           <div class="title-box" v-if="form.beforeStr.orderMap.cancel_reason"><span class="txt1">取消信息</span></div>
           <!-- <div class="item" v-if="form.beforeStr.orderMap.cancel_reason">操作人：{{form.beforeStr.cancelUserMap?form.beforeStr.cancelUserMap.real_name:''}}</div> -->
           <div class="item" v-if="form.beforeStr.orderMap.cancel_reason">原因：{{form.beforeStr.orderMap.cancel_reason}}</div>
           <div class="item" v-if="form.beforeStr.orderMap.cancel_reason">备注：{{form.beforeStr.orderMap.cancel_remark}}</div>
           <div class="item" v-if="form.beforeStr.orderMap.cancel_image_urls">图片：<el-image style="width: 100px; height: 100px" :src="form.beforeStr.orderMap.cancel_image_urls"  :preview-src-list="[form.beforeStr.orderMap.cancel_image_urls]"></el-image></div>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <div class="item">预约状态：{{form.afterStr.orderMap.status | setState}}</div>
          <div class="title-box"><span class="txt1">预约用户信息</span></div>
          <div class="item">姓名：{{form.afterStr.customerMap.name}}</div>
           <div class="item">电话：{{form.afterStr.customerMap.pho}}</div>
           <div class="item">身份：{{form.afterStr.customerMap.level_name}}</div>
           <div class="title-box" v-if="form.afterStr.techInfoMap"><span class="txt1">技术老师信息</span></div>
           <div class="item" v-if="form.afterStr.techInfoMap">姓名：{{form.afterStr.techInfoMap.real_name}}</div>
            <div class="item" v-if="form.afterStr.techInfoMap">电话：{{form.afterStr.techInfoMap.mobile}}</div>
            <div class="item" v-if="form.afterStr.techInfoMap">身份：{{form.afterStr.techInfoMap.level_name}}</div>
           <div class="title-box"><span class="txt1">预约信息</span></div>
           <div class="item">预约类型：{{form.afterStr.orderMap.type==10?'线下服务':'线上服务'}}</div>
           <div class="item">服务类型：{{form.afterStr.orderMap.service_items}}</div>
           <div class="item">地址：{{form.afterStr.orderMap.address}}</div>
           <div class="item">排期时间：{{form.afterStr.orderMap.start_time}}-{{form.afterStr.orderMap.end_time}}</div>
           <div class="title-box" v-if="form.afterStr.orderMap.cancel_reason"><span class="txt1">取消信息</span></div>
           <!-- <div class="item" v-if="form.afterStr.orderMap.cancel_reason">操作人：{{form.afterStr.cancelUserMap?form.afterStr.cancelUserMap.real_name:''}}</div> -->
           <div class="item" v-if="form.afterStr.orderMap.cancel_reason">原因：{{form.afterStr.orderMap.cancel_reason}}</div>
           <div class="item" v-if="form.afterStr.orderMap.cancel_reason">备注：{{form.afterStr.orderMap.cancel_remark}}</div>
           <div class="item" v-if="form.afterStr.orderMap.cancel_image_urls">图片：<el-image style="width: 100px; height: 100px" :src="form.afterStr.orderMap.cancel_image_urls"  :preview-src-list="[form.afterStr.orderMap.cancel_image_urls]"></el-image></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  filters:{
    setState(val){
      switch(val){
        case 10:
          return "待排期";
        case 20:
          return "待服务";
        case 30:
          return "待评论";
        case 40:
          return "已完成";
        case 50:
          return "已取消";
        default:
          return val;
      }
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;
        let obj=JSON.parse(localStorage.getItem("levelList"));
        if(this.form.afterStr && this.form.afterStr.customerMap.c_level){
          this.form.afterStr.customerMap.level_name=obj.find(i=>i.level==this.form.afterStr.customerMap.c_level).name
        }
        if(this.form.afterStr && this.form.afterStr.techInfoMap &&this.form.afterStr.techInfoMap.level_id){
          this.form.afterStr.techInfoMap.level_name=obj.find(i=>i.level==this.form.afterStr.techInfoMap.level_id).name
        }
        if(this.form.beforeStr && this.form.beforeStr.customerMap.c_level){
          this.form.beforeStr.customerMap.level_name=obj.find(i=>i.level==this.form.beforeStr.customerMap.c_level).name
        }
        if(this.form.beforeStr && this.form.beforeStr.techInfoMap&& this.form.beforeStr.techInfoMap.level_id){
          this.form.beforeStr.techInfoMap.level_name=obj.find(i=>i.level==this.form.beforeStr.techInfoMap.level_id).name
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
</style>
